<script setup lang="ts">
import { ref, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useInternationalStore } from '@/store/international'

const internationalStore = useInternationalStore()

const { t } = useI18n()

const MissionVision = computed(() => [
  {
    title: t('About.mission'),
    text: t('About.missiondesp'),
    icon: '#mission'
  },
  {
    title: t('About.vision'),
    text: t('About.visiondesp'),
    icon: '#vison'
  }
])

const list = computed(() => [
  {
    date: '2025.01',
    img: 'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/released-recdot.png',
    title: t('About.list.2501product'),
    info: t('About.list.2501info')
  },
  null,
  {
    date: '2023.05',
    img: 'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/released-nano.png',
    title: t('About.list.2305product'),
    info: t('About.list.2305info')
  },
  null,
  {
    date: '2022.12',
    img: 'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/released-air.png',
    title: t('About.list.2212product'),
    info: t('About.list.2212info')
  },
  null,
  {
    date: '2022.05',
    img: 'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/released-pro-mobile.png',
    title: t('About.list.2205product'),
    info: t('About.list.2205info')
  },
  null,
  {
    date: '2021.06',
    img: 'https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/released-lite.png',
    title: t('About.list.2106product'),
    info: t('About.list.2106info')
  }
])

const selected: any = ref(list.value[0])
const choose = (item: any) => {
  if (item) selected.value = item
}
</script>

<template>
  <main class="about-mobile">
    <!-- Introlbanner -->
    <div class="Introlbanner">
      <div class="Introlbanner-img">
        <div class="title" v-if="internationalStore.location.abb !== 'jp' && internationalStore.location.abb !== 'ja'">{{ $t('About.about') }}<br />{{ $t('About.future') }}</div>
        <div class="title" v-else>{{ $t('About.future') }}<br />{{ $t('About.about') }}</div>
        <div class="text">{{ $t('About.introduce') }}</div>
        <!-- Mission-Vision -->
        <div class="Mission-Vision">
          <div class="card" :class="{ border: index === 0 }" v-for="(item, index) in MissionVision" :key="item.title">
            <svg class="iconpark-icon">
              <use :href="item.icon"></use>
            </svg>
            <div class="text-group">
              <div class="Mission-title">{{ item.title }}</div>
              <div class="Mission-text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- map -->
    <div class="map">
      <div class="title-small">{{ $t('About.maptext') }}</div>
      <div class="title-num">102</div>
      <div class="info">{{ $t('About.maptext2') }}</div>
      <div class="img">
        <img src="https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/map.png" />
      </div>
    </div>
    <!-- Milestones -->
    <div class="Milestones">{{ $t('About.milestones') }}</div>
    <div class="lineStone">
      <div class="date" v-for="item in list" :key="item?.title" @click="choose(item)" :class="{ choosed: selected?.img == item?.img }">
        {{ item?.date }}
      </div>
    </div>
    <div class="cartBox">
      <div class="cartimg">
        <img :src="selected?.img" alt="" />
      </div>
      <div class="cartBox-bottom">
        <div class="titles">{{ selected?.title }}</div>
        <div class="text">{{ selected?.info }}</div>
      </div>
      <!-- <MobileBtn class="Milestones-button" text="LEARN MORE" /> -->
    </div>
  </main>
</template>

<style lang="scss" scoped>
.about-mobile {
  width: 100vw;
  background-color: #f6f6f6;

  .Introlbanner {
    width: 100%;
    background: linear-gradient(180deg, #b2e5f9 0%, #f4f8fb 101.95%);
    overflow: hidden;

    .Introlbanner-img {
      padding: 7.5rem 1.6rem 3rem 1.6rem;
      width: 100%;
      height: 100%;
      background-image: url('https://viaim-h5.oss-ap-southeast-1.aliyuncs.com/iflybuds-website-world/images/about/round-bg.png');
      background-repeat: no-repeat;
      background-position: 80%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      .title {
        color: #000;
        text-align: center;
        font-size: 3.4rem;
        font-style: normal;
        font-weight: 600;
        line-height: 3.8rem;
      }

      .text {
        margin-top: 3.6rem;
        color: rgba(0, 0, 0, 0.6);
        text-align: center;
        font-size: 1.4rem;
        font-style: normal;
        font-weight: 400;
        line-height: 2rem;
      }

      .Mission-Vision {
        padding: 0 3.6rem;
        margin-top: 5rem;
        border-radius: 1.5rem;
        border: 0.5px solid #fff;
        background: rgba(255, 255, 255, 0.42);
        backdrop-filter: blur(38.85273361206055px);

        .card {
          width: 100%;
          aspect-ratio: 343/149;
          flex-shrink: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;

          svg {
            width: 6.4rem;
            height: 6.4rem;
          }

          .text-group {
            margin-left: 2rem;

            .Mission-title {
              color: #000;
              font-family: PingFang SC;
              font-size: 1.8rem;
              font-style: normal;
              font-weight: 500;
              line-height: normal;
            }

            .Mission-text {
              margin-top: 0.6rem;
              color: #a8a8a8;
              font-size: 1.4rem;
              font-style: normal;
              font-weight: 400;
              line-height: normal;
            }
          }
        }

        .border {
          border-bottom: 1px solid #bcbcbc;
        }

        :nth-child(1) {
          margin-right: 0.8rem;
        }
      }
    }
  }

  .map {
    padding-top: 3.3rem;
    margin: 1.6rem;
    width: calc(100% - 3.2rem);
    border-radius: 1.6rem;
    background-color: #fff;
    overflow: hidden;

    .title-small {
      text-align: center;
      color: #202020;
      font-size: 1.7rem;
      font-style: normal;
      font-weight: 500;
      line-height: 2.4rem;
    }

    .title-num {
      margin: 2.2rem 0 0.8rem 0;
      color: #000;
      text-align: center;
      font-family: SF Pro;
      font-size: 8.2rem;
      font-style: normal;
      font-weight: 510;
      line-height: 6.8rem;
    }

    .info {
      color: #717171;
      text-align: center;
      font-size: 1.4rem;
      font-style: normal;
      font-weight: 400;
      line-height: 2.4rem;
    }

    .img {
      margin-top: 1.6rem;
      width: 100%;
      aspect-ratio: 1/0.8;
      position: relative;

      img {
        width: 280%;
        position: absolute;
        left: -55%;
      }
    }
  }

  .Milestones {
    margin: 7.2rem 0 3.8rem 0;
    color: #000;
    font-size: 2.6rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-align: center;
  }

  ::-webkit-scrollbar-track-piece {
    background: #ebebeb;
  }

  ::-webkit-scrollbar {
    width: 0px !important;
  }

  ::-webkit-scrollbar-thumb {
    background: #c9c9c9;
    border-radius: 0px;
  }

  .lineStone {
    width: 100vw;
    overflow: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1.6rem;
    margin: 0 auto;
    margin-bottom: 1.6rem;

    .date:nth-child(2n - 1) {
      display: flex;
      flex-shrink: 0;
      padding: 0.8rem 1.8rem;
      justify-content: center;
      align-items: center;
      gap: 1rem;
      border-radius: 20rem;
      border: 0.1rem solid #d1d1d1;
    }

    .date:nth-child(2n) {
      flex-shrink: 0;
      width: 1.5rem;
      height: 0.1rem;
      background: #d1d1d1;
      margin: 0 0.6rem;
    }

    .choosed {
      color: #fff;
      background: #202020;
    }
  }
  @media screen and (max-width: 630px) {
    .lineStone {
      justify-content: flex-start;
    }
  }

  .cartBox {
    margin: 0 1.6rem 2.4rem 1.6rem;
    padding-bottom: 3.2rem;
    position: relative;
    // width: 100%;
    border-radius: 1.6rem;
    background: #fff;
    overflow: hidden;

    .cartimg {
      width: 100%;
      height: calc(100vw - 3.2rem);
      max-height: 40.8rem;
      overflow: hidden;

      img {
        width: 100%;
        height: calc(100vw - 3.2rem);
        object-fit: cover;
      }
    }

    .cartBox-bottom {
      padding: 2.4rem 2rem 0 2rem;
      font-style: normal;
      line-height: normal;
      position: relative;

      .titles {
        color: #000;
        font-size: 2.2rem;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
      }

      .text {
        margin-top: 0.8rem;
        color: #bebebe;
        font-size: 1.3rem;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        height: 3rem;
      }
    }
  }
}
</style>
